import titleImage from "../assets/7reasons.webp";
import safetyImage from "../assets/safety.webp";

export const blogData = [
  {
    id: "1",
    titile: "7 Reasons to Choose a Local Taxi Over a Ride-Hailing App",
    image: titleImage,
    subtitle: `In today’s fast-moving world, convenience is key. While ride-hailing apps have become popular, many travelers are realizing that local taxi services offer unmatched reliability and service. Here’s why choosing a traditional taxi might be your best bet:`,
    content: [
      {
        title: "1.⁠ ⁠Fixed and Transparent Pricing",
        content:
          "Unlike ride-hailing apps that often increase fares during peak hours or due to demand surges, local taxi services follow a standardized pricing system. You know what to expect, and there are no surprise charges for route changes or traffic delays.",
      },
      {
        title: "2.⁠ ⁠Experienced Local Drivers",
        content:
          "Local taxi drivers know your city inside and out. Whether it’s the fastest route to the airport, avoiding traffic bottlenecks, or knowing shortcuts to your favorite restaurant, they’ve got it covered. You’re in safer hands with someone who has years of city-driving experience.",
      },
      {
        title: "3.⁠ ⁠Personalized Customer Service",
        content:
          "Local taxi operators often value repeat customers and community reputation. You’re not just a number. Drivers tend to go the extra mile—literally and figuratively. Need help with your luggage? Looking for recommendations? They’re happy to help.",
      },
      {
        title: "4.⁠ ⁠Licensed and Regulated",
        content:
          "Local taxi services are typically licensed by government authorities. This means regular inspections, background-verified drivers, and insurance coverage. These extra layers of regulation make local taxis a safer and more trusted option.",
      },
      {
        title: "5.⁠ ⁠Availability Without the App",
        content:
          "Not everyone wants to rely on a mobile app for everything. With a local taxi, you can call or even flag one down on the street. Older adults and tourists especially find this simplicity useful.",
      },
      {
        title: "6.⁠ ⁠Support for Local Economy",
        content:
          "When you ride in a local cab, your money supports neighborhood businesses and families. It circulates within the community rather than going to large corporations that might not even operate locally.",
      },
      {
        title: "7.⁠ ⁠Better During Emergencies and Offline Scenarios",
        content:
          "Imagine your phone dies or you’re in a location with poor internet. In such cases, ride-hailing apps are of no use. Local taxis, on the other hand, are always just a phone call away and more dependable during such situations.",
      },
      {
        title: "Conclusion",
        content:
          "While ride-hailing apps offer convenience, local taxi services bring reliability, safety, and a personal touch that digital platforms often lack. If you care about fixed rates, supporting your local community, and receiving dependable service, then local taxis are the smarter choice.",
      },
    ],
  },
  {
    id: "2",
    titile:
      "Safety Tips While Traveling in a Taxi – What Every Passenger Should Know",
    image: safetyImage,
    subtitle: `Taking a taxi is one of the most convenient ways to get around. Whether you're heading to the airport, a business meeting, or a weekend getaway, safety should always be your top priority. While professional taxi services follow strict safety standards, it's always smart to be aware and stay alert.`,
    content: [
      {
        title: "1.⁠ ⁠Always Book Through Trusted Sources",
        content:
          "Avoid hailing unmarked or unofficial taxis from the street. Instead, book your ride through trusted platforms, verified websites, or well-known local taxi providers. This ensures the cab is registered and the driver is accountable.",
      },
      {
        title: "2.⁠ ⁠Don’t Disclose Personal Information",
        content:
          "Keep conversations with the driver professional and avoid sharing sensitive personal details like your home address (unless it’s your drop location), financial info, or travel plans.",
      },
      {
        title: "3.⁠ ⁠Keep Your Valuables Close",
        content:
          "Carry your wallet, phone, and important documents in a handbag or backpack and keep it on your lap. Avoid placing valuables in the boot unless absolutely necessary.",
      },
      {
        title: "✅ Perform driver background checks",
        content: "",
      },
      {
        title: "✅ Provide 24/7 customer support",
        content: "",
      },
      {
        title: "✅ Enable GPS tracking",
        content: "",
      },
      {
        title: "✅ Offer real-time booking and ride updates",
        content: "",
      },
      {
        title: "Conclusion",
        content:
          "Traveling by taxi should be convenient, comfortable, and—above all—safe. By staying alert and choosing the right taxi service, you can ensure your journey is secure from start to finish.",
      },
    ],
  },
];
